<template>
  <div class="carousel">
    <div class="pane side prev" :class="{selectable: prevPic != null}" @click="prev()">
      <Picture v-if="prevPic != null" :src="prevPic" />
      <div v-else>&nbsp;</div>
    </div>
    <div class="pane current">
      <Picture :src="currentPic" :shadow="true" />
    </div>
    <div class="pane side next" :class="{selectable: nextPic != null}" @click="next()">
      <Picture v-if="nextPic != null" :src="nextPic" />
      <div v-else>&nbsp;</div>
    </div>
  </div>
</template>

<style scoped>
.carousel {
  padding: 0 2em;
  display: table-row;
  user-select: none;
}

.pane {
  display: table-cell;
  height: 100vh;
  padding: 1em;
  vertical-align: middle;
  box-sizing: border-box;
}

.current {
  width: 70%;
}

.side {
  width: 14%;
  transform-origin: middle left;
  filter: blur(2px);
  transition: all 0.2s ease;
  background: transparent;
}

.side.selectable {
  cursor: pointer;
}

.side.selectable:hover {
  filter: blur(1.4px) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.3));
}

.next:hover {
  transform: scaleX(0.9) skew(0, 4deg) scale(1.05) translateX(-5%);
}

.prev:hover {
  transform: scaleX(0.9) skew(0, -4deg) scale(1.05) translateX(5%);
}

.next {
  transform: scaleX(0.9) skew(0, 5deg);
}

.prev {
  transform: scaleX(0.9) skew(0, -5deg);
}
</style>

<script>
import pics from "./pics.js";
import Picture from "./Picture";

export default {
  components: { Picture },
  data() {
    return {
      pics,
      position: 0
    };
  },
  methods: {
    next() {
      if (this.nextPic != null) this.position++;
    },
    prev() {
      if (this.prevPic != null) this.position--;
    }
  },
  computed: {
    currentPic() {
      return this.pics[this.position];
    },
    nextPic() {
      if (this.position < this.pics.length - 1) {
        return this.pics[this.position + 1];
      }
      return null;
    },
    prevPic() {
      if (this.position > 0) {
        return this.pics[this.position - 1];
      }
      return null;
    }
  }
};
</script>